export enum SubscriberGate {
  POPUP = 'popup',
  GATED = 'gated',
  FORM = 'form',
  NONE = 'none',
}

export enum ButtonPlacement {
  INLINE = 'inline',
  BOTTOM = 'bottom',
}
